import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import AdminApp from "./admin";
const rootElement = document.getElementById("spwa-admin-root");
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(_jsx(AdminApp, {}));
}
